import { CompetitionDivisionForm } from './components/division-form';
import { useCreateCompetitionDivisionMutation } from '../mutations';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { Schema } from './components/division-form.schema';
import { formatDate, startOfYear } from '~/utils/date';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { idParamSchema } from '~/schemas';
import { toast } from 'react-toastify';

export const Page = withPrivateRoute(() => {
  const mutation = useCreateCompetitionDivisionMutation();
  const navigate = useNavigate();

  const { id } = useParams(idParamSchema.parse);

  async function onSubmit(payload: Schema) {
    await toast.promise(
      mutation.mutateAsync({
        ...payload,
        competition: id,
      }),
      {
        success: 'Lagtävlingsdivisionen har skapats',
        pending: 'Skapar lagtävlingsdivisionen...',
      }
    );
    navigate(-1);
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Skapa lagtävlingsdivision" />

      <PageLayout.Section>
        <CompetitionDivisionForm
          onSubmit={onSubmit}
          isLoading={mutation.isPending}
          mode="create"
          defaultValues={{
            nomination_start_date: formatDate(startOfYear(), 'yyyy-mm-dd'),
            nomination_end_date: formatDate(new Date(), 'yyyy-mm-dd'),
          }}
        />
      </PageLayout.Section>
    </Fragment>
  );
});
